const components = {
  HeaderSetting: {
    changethepassword: "Change the password",
    logout: "Log out",
    enter1: "Please enter the old password",
    enter2: "Please enter your new password",
    enter3: "Please enter the new password again",
    confirm: "Confirm",
    cancel: "Cancel",
    error1: "Please enter the old password",
    error2: "Please enter your new password",
    error3: "The minimum password length is 6 digits",
    error4: "Input password is inconsistent",
    error5: "Please enter a new password again",
    message1: "Password change successful",
    message2: "Password change failed",
    inputlabelwidth: "225px"
  }
} 
export default components